export const categoryDetails = [
    {
        id: 1,
        default: require('@/assets/眼眉/4_1.jpg'),
        active: require('@/assets/眼眉/4_1.jpg'),
        describe1: '柔焦雾感塑形眉笔',
        describe2: '顺滑持久 自然塑形',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.55.a422e0612ghNm5&id=586027108988&rn=afbb019122ba33d305db9762f0fd1b4d&abbucket=17'
    },
    {
        id: 2,
        default: require('@/assets/眼眉/4_2.jpg'),
        active: require('@/assets/眼眉/4_2.jpg'),
        describe1: '纤细「小三角」眉笔',
        describe2: '精准勾勒眉型',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.50.a422e0612ghNm5&id=586502751254&rn=afbb019122ba33d305db9762f0fd1b4d&abbucket=17'
    },
    {
        id: 3,
        default: require('@/assets/眼眉/4_3.jpg'),
        active: require('@/assets/眼眉/4_3.jpg'),
        describe1: '防水塑形眉膏',
        describe2: '顺滑触感 一笔成型',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.60.a422e0612ghNm5&id=574881270574&rn=afbb019122ba33d305db9762f0fd1b4d&abbucket=17'
    }
]